import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const Title = styled(Heading2)`
  font-size: 16px;
  margin-bottom: 4px;
`

export const Subtitle = styled(Body)`
  margin: 0 auto 30px;
  max-width: 450px;
`

export const SpendCard = styled.img`
  width: 100%;
  box-shadow: 0px 20px 53px 0px rgba(0, 0, 0, 0.1), 0px 7px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 13px;
`

export const SpendCardContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 295px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

type CustomerNameInputType = {
  displayName: string
}

export const CustomerName = styled.p`
  position: absolute;
  // For names larger than 32 characters, use a smaller font-size to make it fit
  font-size: ${(props: CustomerNameInputType) =>
    props.displayName && props.displayName.length < 32 ? 10 : 9}px;
  color: #404727;
  text-transform: uppercase;
  top: 50%;
  transform: translateY(-50%);
  left: 14px;
  text-align: left;
`

export const CustomerSignatureContainer = styled.div`
  position: absolute;
  top: 38%;
  transform: translateY(-50%);
  left: 12px;
  width: 110px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CustomerSignature = styled.img`
  max-width: 110px;
  height: auto;
  max-height: 45px;
`

export const EditSignature = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${style(theme => theme.colors.stone)};
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  margin-top: 10px;
`

export const EditAddress = styled(EditSignature)`
  padding: 15px 0;
  margin: 0;
`

export const MailingAddressContainer = styled.div`
  width: 295px;
  border: 1px solid ${style(theme => theme.colors.ivory)};
  border-radius: 4px;
  margin: 30px auto 50px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 30px auto 20px;
    width: 100%;
  }
`

export const AddressContainer = styled.div`
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid ${style(theme => theme.colors.ivory)};

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    text-align: left;
  }
`

export const MailTo = styled(Body)`
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 14px;
`

export const Address = styled(Body)`
  line-height: 22px;
  // For names larger than 32 characters, use a smaller font-size to make it fit
  font-size: ${(props: CustomerNameInputType) =>
    props.displayName && props.displayName.length < 32 ? 14 : 12}px;
`
